import * as React from "react";
import classnames from "classnames";
/* empty css                      */
const StoreTileSection = ({ asideSlot, children, className, marginBottom, ...rest }) => {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...rest,
      className: classnames("store-tile__section", className, {
        [`mb--${marginBottom}`]: marginBottom
      })
    },
    asideSlot ? /* @__PURE__ */ React.createElement("div", { className: "store-tile__section-wrapper" }, /* @__PURE__ */ React.createElement("div", null, children), /* @__PURE__ */ React.createElement("div", { className: "store-tile__section--aside" }, asideSlot)) : children
  );
};
export {
  StoreTileSection as default
};
//# sourceMappingURL=StoreTileSection.js.map
